import $ from "jquery";
import {toast} from "react-toastify";

// Content generated by gulp-markdown-it only produces plain <pre><code> blocks,
// so wrap them in the same .listing markup the Microsoft Learn-sourced tutorial
// pages already ship with, before attachCopyTagHandlers wires up the click handler.
export function injectCopyButtons(container){

    const $scope = container ? $(container) : $(document);

    $scope.find('pre').each(function () {
        const $pre = $(this);

        if ($pre.closest('.listing').length > 0) {
            return;
        }

        $pre.addClass('listing-pre');
        $pre.wrap('<div class="listing"></div>');
    });

    // Overlay a small icon-only copy button pinned to the top-right corner of the
    // code area itself. It lives in a non-scrolling wrapper around <pre>, as a sibling
    // rather than a child of it, so it stays put when the code scrolls horizontally
    // (pre has its own overflow-x) and clears the pre's own scrollbar since it sits
    // above the scrolling box rather than inside it.
    $scope.find('.listing-pre').each(function () {
        const $pre = $(this);

        if ($pre.parent().hasClass('listing-pre-wrap')) {
            return;
        }

        $pre.wrap('<div class="listing-pre-wrap"></div>');
        $pre.before(
            '<button class="listing-action listing-action-overlay" aria-label="Copy code" title="Copy">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
                    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>' +
                    '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>' +
                '</svg>' +
            '</button>'
        );
    });
}

function copyTextToClipboard(text){
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }

    // Fallback for browsers/contexts without the async Clipboard API
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand('copy');
    } finally {
        document.body.removeChild(textArea);
    }

    return Promise.resolve();
}

export function attachCopyTagHandlers(){

    //console.log("Checking for Tags and copy buttons");

    const copy = $('button.listing-action');
    const tags = $('span.js-tag-group-entry');

    //console.log('Tags :' + tags.length + '  ' + tags[0].innerHTML);
    //console.log("Copy :" + copy.length);

    copy.off('click').on('click', function() {
        const data = $(this).closest('.listing').find('.listing-pre code').first().text();

        copyTextToClipboard(data).catch((err) => console.error('Failed to copy to clipboard', err));

        const message = ({ closeToast }) => (
            <div className="toasty-preview">
                <p>Content copied to clipboard</p>
                <button onClick={closeToast}>Dismiss</button>
            </div>
        )
        toast(message, {
            toastId: '007',
            autoClose: 2500,
            className: 'copy-toast'
        });
    });

    // With the current setup the handler can be added multiple times
    tags.off('click').on('click', function() {
        const data = $(this).text();

        console.log('Tag clicked with tag: ' + data);

        const message = ({ closeToast }) => (
            <div>
                <p><strong>{data}</strong></p>
                <p>Tag search is currently disabled</p>
                <button onClick={closeToast}>Dismiss</button>
            </div>
        )
        toast(message, {
            toastId: '007',
            autoClose: 2500
        });
    });

}